import Form_6 from './Form_6-redux';

export default Form_6;
